<template>
    <transition enter-active-class="animated fadeIn">
        <div id="allbot" v-show="!isLoading" key="content">
            <div class="accounts">
                <div class="header">
                    <div class="row">
                        <div class="col-xs-6">
                            <div class="logo">
                                <img :src="$store.state.theme.small_logo" alt="" style="max-width: 100%; width: auto">
                            </div>
                        </div>
                        <div class="col-xs-6 text-right">
                            <a href="javascript:void(0);" class="btn btn-primary transparent" style="margin-right:15px;" @click="logout">
                                <span class="glyphicon glyphicon-off"></span> Logout
                            </a>
                        </div>
                    </div>
                </div>
                <div class="pages container text-center">
                    <h1 class="title">SELECT BOT TO MANAGE</h1>
                   <div style="position:relative" :class="{ 'no-bot' : !botlist || botlist.length == 0}">
                        <span class="tooltiptext" v-if="!botlist || botlist.length == 0" style="width:214px;margin-left:-107px;top:-35px;z-index: 0;">Click this button to start</span>

                        <ul>
                            <li class="page" v-for="(bot) in botlist" :key="'bot_'+bot.pageid" v-tooltip.top="bot.pagename" @click="onSelectedBot(bot)">
                                <img @error="imgError" :src="'https://graph.facebook.com/'+ bot.pageid +'/picture?width=300&height=300'" alt="">
                                <div class="page-name">{{bot.pagename | truncate(20)}}</div>
                            </li>
                            <li v-if="isFacebook" @click="isAdd = true">
                                <div class="add-page">
                                    <div class="middle" style="margin-left:-16px;margin-top:-26px;">
                                        <h1 class="text-center" style="margin:0">
                                            <div class="plus" style="margin-bottom:5px;">
                                                <span class="glyphicon glyphicon-plus"></span>
                                            </div>
                                            <!-- <div>ADD</div> -->
                                        </h1>
                                    </div>
                                </div>
                                <div class="page-name">ADD</div>
                            </li>
                        </ul>
                   </div>
                </div>
            </div>

            <subscribe-bot v-if="isAdd" @close="isAdd = false" :themes="themelist"></subscribe-bot>
        </div>
    </transition>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import api from '@/api'
import config from '@/config'
import SubscribeBot from './SubscribeBot'

export default{
	data: function(){
		return {
            pagelist: this.$store.state.pagelist,
            isLoading: true,
            isAdd: false,
            themelist: []
			 
		}
	},
	components: {
		SubscribeBot
	},
	mounted: function(){
        let vm = this
        vm.$store.dispatch('loading')
        vm.getAllPublicTheme(function(){
            vm.$store.dispatch('updatePagelist')
            
            if (vm.isFacebook) {
                let pageidlist = []
                $.each(vm.pagelist, function(index , val){
                    if (val.perms) {
						
						if (val.perms.indexOf('ADMINISTER') > -1 || val.perms.indexOf('EDIT_PROFILE') > -1) {
							pageidlist.push(val.id);
						}
					}
					if (val.tasks) {
						if (val.tasks.indexOf('MANAGE') > -1 || val.tasks.indexOf('CREATE_CONTENT') > -1) {
							pageidlist.push(val.id);
						}
					}
                })
                let data = { 
                    userid : vm.$store.state.userid ,
                    pageidlist : pageidlist,
                    access_token: vm.$store.state.fbAccessToken 
                }
                vm.$store.dispatch('getBotlist',data).then(response => {
                    vm.$store.dispatch('loading')
                    vm.isLoading = false
                    if (!vm.botlist || vm.botlist.length <= 0) {
                        vm.isAdd = true
                    }
                }, error => {
                    vm.$store.dispatch('loading')
                    // console.log('error')
                })
            } else {
                vm.$store.dispatch('loading')
                vm.isLoading = false
                if (!vm.botlist || vm.botlist.length <= 0) {
                    vm.isAdd = true
                }
                
            }
        })
	},
	computed: {
	    ...mapGetters({
	        selectedBot: 'selectedBot',
            botlist: 'botlist',
            isFacebook: 'isFacebook'
	      }),
	},
	methods: {
        onSelectedBot: function(bot){
            this.$store.dispatch('selectBot',bot)
            this.$router.push("/dashboard")
        },
        logout: function() {
            if (confirm("Do you want to logout?")) {
                var isFacebook = this.isFacebook
                this.$store.dispatch('logout',null).then();
                if (isFacebook) {
                    this.$router.push('/login')
                } else {
                    this.$router.push('/nigol')
                }
            } 
        },
        getAllPublicTheme: function(callback){
            let vm = this
            api.getAllPublicTheme({appid : config.appid}, function(error, response){
                if (error) {
                    console.error(error)
                    return
                }

                vm.themelist = response.data	
                callback()			
            })
        },
		selectBot: function(pageid,event) {
			const bot = this.botlist.find(bot => {
		      return bot.pageid == pageid
		    })
			this.$store.dispatch('selectBot',bot)
        },
        imgError: function(event){
            $(event.target).attr('src','/static/img/assets/livechat/profile.png')
            // this.value.profile_pic = '/static/img/assets/livechat/profile.png'
        },
	}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/allbots/Account.vue